import type { MouseEventHandler, Ref } from 'react';
import XIcon from '../../icons/react/icon-x';
import { Pill, type PillProps } from './pill';

interface RemovablePillProps extends Omit<PillProps<'button'>, 'affixIcon'> {
  onClick: MouseEventHandler<HTMLButtonElement>;
  ref?: Ref<HTMLButtonElement>;
}

export function RemovablePill({ onClick, ref, ...rest }: RemovablePillProps) {
  return (
    <Pill
      affixIcon={
        <button aria-label="Remove item" onClick={onClick} type="button">
          <XIcon aria-hidden height={16} />
        </button>
      }
      ref={ref}
      {...rest}
    />
  );
}
